import { ISapPayloadItem } from "../../../types"

export interface IProductEditDraft {
  recordId: string
  payload: ISapPayloadItem[]
  savedAt: string
  baseUpdatedAt: string | null
}

const DRAFT_STORAGE_PREFIX = "sapprd-edit-draft:"

const getDraftKey = (recordId: string): string => `${DRAFT_STORAGE_PREFIX}${recordId}`

export const getProductEditDraft = (recordId: string): IProductEditDraft | null => {
  try {
    const rawDraft = window.localStorage.getItem(getDraftKey(recordId))
    if (!rawDraft) return null

    const parsedDraft = JSON.parse(rawDraft) as IProductEditDraft
    if (!parsedDraft || parsedDraft.recordId !== recordId || !Array.isArray(parsedDraft.payload)) {
      window.localStorage.removeItem(getDraftKey(recordId))
      return null
    }

    return parsedDraft
  } catch (_error) {
    window.localStorage.removeItem(getDraftKey(recordId))
    return null
  }
}

export const saveProductEditDraft = (draft: IProductEditDraft): void => {
  window.localStorage.setItem(getDraftKey(draft.recordId), JSON.stringify(draft))
}

export const removeProductEditDraft = (recordId: string): void => {
  window.localStorage.removeItem(getDraftKey(recordId))
}
